export {Select} from './select'
export * from './interfaces'

export const SELECT_ELEMENTS = {
  SELECT: 'select-select',
  VALUE: 'select-value',
  OPTION: 'select-option',
  OPTIONS: 'select-options',
}
